export default __webpack_public_path__ + "static/media/collect_responses.ec0a29dc.svg";